import styled from 'styled-components'

import { COLOURS } from 'resources'
import PrimaryLink from 'units/PrimaryLink'

export const ScreenContainer = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
`

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  max-width: 400px;
  width: 100%;
`

export const WelcomeTitle = styled.div`
  font-weight: 700;
  font-style: italic;
  font-size: 16px;
`

export const WelcomeMessageContainer = styled.div`
  margin-top: 15px;
  font-family: 'Druk', sans-serif;
  font-size: 70px;
  line-height: 1;
  justify-content: column;
`

export const WelcomeMessageText = styled.span``

export const WelcomeMessageRedText = styled.span`
  color: ${COLOURS.secondaryRed1};
`

export const QRCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
`

export const QRCodeLink = styled(PrimaryLink)`
  margin-top: 20px;
  font-size: 18px;
`
